import type { ReactNode } from 'react';

/**
 * La columna del paciente: el ancho de un teléfono, centrada, aunque se abra en
 * una pantalla grande.
 *
 * La ponía la ruta `/` para todo lo que muestra. Desde el 06/10 la ponen las
 * pantallas que la necesitan —el onboarding, la carga, sin conexión—, porque la
 * puerta de entrada (`ValidacionMagicLink`) usa el ancho de la ventana en
 * escritorio para entrar entera, aviso de demostración incluido, sin scroll.
 */
export function ColumnaDelPaciente({ children }: { children: ReactNode }) {
  return <div className="mx-auto flex w-full max-w-lg flex-1 flex-col">{children}</div>;
}
